<template>
  <div>
    <div class="warpper_top">
      <h1 class="warpper_top_title">系统设置</h1>
    </div>
    <div class="warpper_con">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules">
        <!-- <a-form-model-item colon label="公司名称" prop="companyName" >
          <a-input class="w360" v-model="dataInfo.companyName" :max-length="25" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item colon label="公司LOGO" prop="companyLogoUrl">
          <upload-cmp
            :img-url="fileInfo && fileInfo.fileName ? fileInfo.fileName : ''"
            type="image"
            @fileUrlFn="fileUrlFn"
          ></upload-cmp>
          <a-input class="w360" v-show="1 === 2" v-model="dataInfo.companyLogoUrl" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item colon label="公司所在地" prop="companyProvinceId">
          <a-select
            class=""
            :default-value="provinceList[0]"
            v-model="dataInfo.companyProvinceId"
            style="width: 120px"
            @change="handleProvinceChange"
          >
            <a-select-option v-for="province in provinceList" :value="province.areaId" :key="province.areaId">
              {{ province.areaName }}
            </a-select-option>
          </a-select>

          <a-select v-model="dataInfo.companyCityId" style="width: 120px; margin-left: 10px; margin-right: 10px">
            <a-select-option v-for="city in showCityList" :value="city.areaId" :key="city.areaId">
              {{ city.areaName }}
            </a-select-option>
          </a-select>
          <a-input class="w600" v-model="dataInfo.companyAddress" :max-length="50" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item colon label="首页标语" prop="indexCarousel">
          <a-input class="w600" v-model="dataInfo.indexCarousel" :max-length="50" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item colon label="首页业绩显示类型" prop="indexPerformanceShowType">
          <a-select default-value="week" v-model="dataInfo.indexPerformanceShowType" style="width: 100px">
            <a-select-option value="week">周</a-select-option>
            <a-select-option value="month">月</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item colon label="负责人姓名" prop="principalName">
          <a-input class="w360" v-model="dataInfo.principalName" :max-length="20" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item colon label="负责人电话" prop="principalPhone">
          <a-input class="w360" :maxLength="11" v-model="dataInfo.principalPhone" placeholder="请输入" />
        </a-form-model-item> -->
      </a-form-model>
      <div class="btn_center">
        <a-button type="primary" @click="submitForm"> 保存 </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sysList,
  getSys,
  addSys,
  updateSys,
  // , delSys
} from '@/api/setting/sys'
import { areaList } from '@/api/setting/area'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'
import UploadCmp from '@/components/UploadCmp/index'

export default {
  name: 'SysSetting',
  components: {
    UploadCmp,
  },
  mixins: [tableMixin],
  data() {
    return {
      total: 0,
      list: [],
      dataObj: {},
      loading: false,
      submitLoading: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
      },

      queryArea: {
        areaName: undefined, //	名称
        level: undefined, // 等级（1：省 2：市 3：区）
        parentId: undefined, //	父类ID
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      showCityList: [],

      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      dataInfo: {
        indexPerformanceShowType: 'week', // 首页业绩显示类型 （week：周 month：月）
        companyAddress: undefined, // 详细地址
        companyCityId: undefined, // 市ID
        companyLogoUrl: undefined, // 公司logo url
        companyName: undefined, // 公司名称
        companyProvinceId: undefined, // 省ID
        id: undefined, // id，新增时不传，修改时必传
        indexCarousel: undefined, //	首页轮播
        principalName: undefined, //	负责人姓名
        principalPhone: undefined, // 负责人电话
        companyLogoUrlList: [
          // 公司logourl List	array	SysOss
          {
            createBy: undefined, //	创建者	string
            createTime: undefined, //	创建时间	string
            fileName: undefined, //		string
            fileSuffix: undefined, //		string
            originalName: undefined, //		string
            ossId: undefined, //	integer
            params: undefined, //	请求参数	object
            searchValue: undefined, //	搜索值	string
            service: undefined, //	string
            updateBy: undefined, //	更新者	string
            updateTime: undefined, //	更新时间	string
            url: undefined, //
          },
        ],
      },
      fileInfo: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: '',
      },
      rules: {
        indexPerformanceShowType: [{ required: true, message: '必填', trigger: 'change' }],
        companyAddress: [{ required: true, message: '必填', trigger: 'blur' }],
        companyProvinceId: [{ required: true, message: '必填', trigger: 'blur' }],
        companyCityId: [{ required: true, message: '必填', trigger: 'blur' }],
        companyLogoUrl: [{ required: true, message: '必填', trigger: 'blur' }],
        companyName: [{ required: true, message: '必填', trigger: 'blur' }],
        indexCarousel: [{ required: true, message: '必填', trigger: 'blur' }],
        principalName: [{ required: true, message: '必填', trigger: 'blur' }],
        principalPhone: [
          { required: true, message: '必填', trigger: 'blur' },
          { pattern: /^1[3-9][0-9]{9}/, message: '格式错误', trigger: 'blur' },
        ],
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*', // multipart/form-data
      },
      columns: [],
    }
  },
  filters: {},
  created() {
    this.getArea()
  },
  computed: {},
  watch: {},
  methods: {
    getArea() {
      this.loading = true
      areaList(this.queryArea).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          const provinceList = []
          const cityList = []
          const areaList = []
          if (resData != null && resData.length > 0) {
            for (let i = 0; i < resData.length; i++) {
              const level = resData[i].level
              if (level === 1) {
                provinceList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
              }
              if (level === 2) {
                cityList.push({
                  areaId: resData[i].areaId,
                  areaName: resData[i].areaName,
                  parentId: resData[i].parentId,
                  children: [],
                })
              }
              if (level === 3) {
                areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
              }
            }
            this.provinceList = provinceList
            this.cityList = cityList
            this.areaList = areaList
          }
          this.getList()
        }
        this.loading = false
      })
    },
    /** 查询系统设置信息列表 */
    getList() {
      this.loading = true
      sysList(this.queryParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.total = resData.total
          if (this.total > 0) {
            this.list = resData.records
            this.dataObj = resData.records[0]
            this.dataInfo = this.dataObj
            this.handleProvinceChange(this.dataInfo.companyProvinceId)

            const fileObj = this.dataInfo.companyLogoUrlList[0]
            this.fileInfo = fileObj
          }
        }
        this.loading = false
      })
    },

    submitForm() {
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateSys(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addSys(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    getDetail() {
      const sysId = this.dataInfo.id
      getSys(sysId).then((response) => {
        this.dataInfo = response.data
      })
    },

    fileUrlFn(file) {
      console.log(file)
      this.dataInfo.companyLogoUrl = file.ossId + ''
      this.fileInfo = file
    },

    handleProvinceChange(value) {
      this.showCityList = []
      for (let i = 0; i < this.cityList.length; i++) {
        const city = this.cityList[i]
        if (city.parentId === value) {
          this.showCityList.push(city)
        }
      }
      this.dataInfo.companyCityId = this.showCityList[0].areaId
    },
  },
}
</script>

<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.w360 {
  width: 360px;
}
.w600 {
  width: 600px;
}
.warpper_top,
.warpper_con {
  background: #fff;
  padding: 20px;
}
.warpper_con {
  margin-top: 10px;
}
.warpper_top_title {
  font-size: @titleFontSize;
  color: @titleColor;
  font-weight: bold;
}
.btn_center {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
